import i18n from '@vue-storefront/i18n'
import { Logger } from '@vue-storefront/core/lib/logger'
import { mapGetters } from 'vuex'

export const Register = {
  name: 'Register',
  data () {
    return {
      email: '',
      firstName: '',
      lastName: '',
      phoneNumber: '',
      password: '',
      rPassword: '',
      conditions: false
    }
  },
  computed: {
    ...mapGetters({
      getCartToken: 'cart/getCartToken'
    })
  },
  methods: {
    switchElem () {
      // TODO Move to theme
      this.$store.commit('ui/setAuthElem', 'login')
    },
    close () {
      // TODO Move to theme
      this.$bus.$emit('modal-hide', 'modal-signup')
    },
    callRegister () {
      // TODO Move to theme
      this.$bus.$emit('notification-progress-start', i18n.t('Registering the account ...'))
      this.$store.dispatch('user/register', { email: this.email, phone: this.phoneNumber, password: this.password, firstname: this.firstName, lastname: this.lastName, quoteId: this.getCartToken })
        .then(async (result) => {
          Logger.debug(result, 'user')()
          // TODO Move to theme
          this.$bus.$emit('notification-progress-stop')
          if (result.code !== 200) {
            let message = result.result && result.result.hasOwnProperty('error') ? { result: result.result.error } : result
            message = message.result.hasOwnProperty('status') && message.result.status === 'error' ? { result: message.result.message } : message
            this.onFailure(message)

            // If error includes a word 'password', focus on a corresponding field
            if (result.result.password && result.result.includes('password')) {
              this.$refs['password'].setFocus('password')
              this.password = ''
              this.rPassword = ''
            }
          } else {
            await this.$store.dispatch('user/login', { email: this.email, password: this.password })
            this.onSuccess()
          }
        })
        .catch(err => {
          // TODO Move to theme
          this.onFailure({ result: 'Unexpected authorization error. Check your Network conection.' })
          this.$bus.$emit('notification-progress-stop')
          Logger.error(err, 'user')()
        })
    }
  }
}
